import { render, staticRenderFns } from "./PostalCodeDetail.vue?vue&type=template&id=510e3eca&scoped=true"
import script from "./PostalCodeDetail.vue?vue&type=script&lang=js"
export * from "./PostalCodeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e3eca",
  null
  
)

export default component.exports